import 'css-chunk:src/dev-tools/ReceiptPrintTool.module.scss';export default {
  "root": "ReceiptPrintTool_root",
  "input": "ReceiptPrintTool_input",
  "cta": "ReceiptPrintTool_cta"
};